import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { Voucher } from '../../models/voucher.model';



export const VouchersApiActions = createActionGroup({
  source: 'Vouchers API',
  events: {
    'Fetch Vouchers': emptyProps(),
    'Retrieved Vouchers': props<{ vouchers: Voucher[] }>(),
    
    'Post Voucher': props<{ code: string }>(),
    'Failed To Add Voucher': emptyProps(),
    'Succeeded To Add Voucher': emptyProps(),
    
    'Fetch Voucher PDF': props<{ voucherId: number }>(),
    'Retrieved Voucher PDF': props<{ voucherId: number }>(),
  },
});
